import api from "api";
import { push } from "connected-react-router";
import { delay } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";

import { policies, users } from "../actions";
import {
  ADD_USER_START,
  FETCH_USERS_START,
  REMOVE_USER_START
} from "../constants";
import selectors from "../selectors";
import { fetchPagedSagaFactory, REFRESH_DELAY } from "./utils";

/* sagas */
export const usersSaga = fetchPagedSagaFactory(
  api.Users.get,
  users.success,
  users.failed
);

export function* fetchUserByUsernameSaga(username) {
  try {
    const { response } = yield call(api.Users.getByUsername, username);
    yield put(users.success(response));
    return response;
  } catch (error) {
    yield put(users.failed(error));
    return undefined;
  }
}

export function* addUserSaga(username) {
  try {
    const { response } = yield call(api.Users.create, username);
    yield put(users.addSuccess(response));
    return response;
  } catch (error) {
    yield put(users.addFailed(error));
    return undefined;
  }
}

export function* removeUserSaga(action) {
  try {
    const { user } = action;

    yield call(api.Users.delete, user);

    // Ensure server state has updated
    yield call(delay, REFRESH_DELAY);

    // Remove policies associated with user from state
    const policiesToRemove = yield select(selectors.policies.getByCurrentUser);

    yield put(policies.commitDeleteSuccess(policiesToRemove));
    yield put(users.removeSuccess(user));
    yield put(users.request());
    yield put(policies.request());
  } catch (error) {
    yield put(users.removeFailed(error));
  }
}

export function* addUserModalSaga(action) {
  try {
    const { username } = action;
    const user = yield call(addUserSaga, username);
    // Ensure server state has updated,
    // before refreshing.
    if (user) {
      yield put(push("/policies"));
      yield call(delay, REFRESH_DELAY);
      // refresh users
      yield put(users.request());
    }
  } catch (error) {
    yield put(users.addFailed(error));
  }
}

export function* watchUsers() {
  yield takeLatest(FETCH_USERS_START, usersSaga);
}

export function* watchAddUser() {
  yield takeLatest(ADD_USER_START, addUserModalSaga);
}

export function* watchRemoveUser() {
  yield takeLatest(REMOVE_USER_START, removeUserSaga);
}
